import React, { useState, useEffect } from "react";
import theme from "../styles/theme";
import PageHeader from "../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../components/reusable/ModuleHeader/Breadcrumb";
import Button from "../components/reusable/Forms/Button";
import TextFilter from "../components/reusable/Forms/TextFilter";
import InfoPanel from "../components/reusable/Forms/InfoPanel";
import Switch from "../components/reusable/Forms/Switch";
import SwitchGroup from "../components/reusable/Forms/SwitchGroup";
import BadgesSplitView from "../components/reusable/Navigation/BadgesSplitView";
import UserAvatar from "../components/reusable/Forms/UserAvatar";
import RadioGroup from "../components/reusable/Forms/RadioGroup";
import CheckboxGroup from "../components/reusable/Forms/CheckboxGroup";
import TextfieldGroup from "../components/reusable/Forms/TextfieldGroup";
import DropdownlistGroup from "../components/reusable/Forms/DropdownlistGroup";
import KpiSummaryList from "../components/reusable/Forms/KpiGroup";
import KpiSummary from "../components/reusable/Forms/KpiSummary";
import Input from "../components/reusable/Forms/Input";
import InputGroup from "../components/reusable/Forms/InputGroup";
import TextArea from "../components/reusable/Forms/TextArea";
import DropdownList from "../components/reusable/Forms/DropdownList";
import DropdownMulti from "../components/reusable/Forms/DropdownMulti";
import PhoneInput from "../components/reusable/Forms/PhoneInput";

import FormLayout from "../components/reusable/Forms/FormLayout";







import { API_ROUTES } from "../config/api";


const SettingsSubpage = () => {



  // --------------------------------------------------------------------------
  // 1. États globaux du composant
  // --------------------------------------------------------------------------
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);



  
  // --------------------------------------------------------------------------
  // 2. Chargement API d’exemple (facultatif)
  // --------------------------------------------------------------------------
  useEffect(() => {
    const ac = new AbortController();

    // --- Fonction de normalisation (corrige les variations d’identifiant)
    const normalizeList = (list) => {
      return (Array.isArray(list) ? list : []).map((item) => ({
        ...item,
        id: item.id ?? item.Id ?? item.ID ?? null,
      }));
    };

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(API_ROUTES.projects.getAll, { signal: ac.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const list = await res.json();
        if (!ac.signal.aborted) setData(normalizeList(list));
      } catch (err) {
        if (!ac.signal.aborted) setError("Erreur de chargement des données");
        console.error(err);
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };

    load();
    return () => ac.abort();
  }, []);

  // --------------------------------------------------------------------------
  // 3. Bloc d’affichage du statut de chargement (réutilisable)
  // --------------------------------------------------------------------------
  const StatusBlock = () => {
    if (loading) return <p style={{ color: theme.colors.text.secondary }}>Chargement…</p>;
    if (error) return <p style={{ color: theme.colors.text.danger }}>{error}</p>;
    if (!data.length) return <p style={{ color: theme.colors.text.small }}>Aucune donnée</p>;
    return <p style={{ color: theme.colors.text.small }}>Données chargées : {data.length}</p>;
  };

  // ========================================================================
  // 4. Onglet 1 — Exemple : Création / Suppression
  // ========================================================================
  const TabOne = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [switchOn, setSwitchOn] = useState(false);
    
    // RadioButton Horizontal
    const [selectedHorRadioOptions, setSelectedHorRadioOptions] = useState("option1");
    const horRadioOptions = [
      { label: "Option 1", value: "option1" },
      { label: "Option 2", value: "option2" },
      { label: "Option 3", value: "option3" },
    ];
    // RadioButton Vertical
    const [selectedVerRadioOptions, setSelectedVerRadioOptions] = useState("option1");
    const verRadioOptions = [
      { label: "Option 1", value: "option1" },
      { label: "Option 2", value: "option2" },
      { label: "Option 3", value: "option3" },
    ];
    // Switch Vertical
    const [switchVer1, setSwitchVer1] = useState(false);
    const [switchVer2, setSwitchVer2] = useState(false);

    const [formData, setFormData] = useState({
      status: "",
      role: "",
      priority: "",
    });
    const handleDropdownChange = (name, value) => {
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  

    return (
      <div>
        {/* Barre d’actions principale */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing.md,
          }}
        >
          {/* Boutons à gauche */}
          <div style={{ display: "flex", gap: theme.spacing.md, marginLeft: 25 }}>
            <Button variant="blue">Create</Button>
            <Button variant="red">Delete</Button>
          </div>

          {/* Barre de recherche au centre */}
          <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md, width: 600 }}>
            <TextFilter
              label="Recherche"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher..."
            />
          </div>

          {/* Switch à droite */}
          <div style={{ display: "flex", alignItems: "center", marginRight: 25 }}>
            <Switch
              label="Actifs"
              enabled={switchOn}
              onChange={setSwitchOn}
              showText={false}
              size="small"
              switchStyle={{ transform: "translateY(2px)" }}
            />
          </div>
        </div>

        {/* Statut API */}
        {/* <StatusBlock /> */}

        {/* Container Principal du Formulaire */}  
          <div
            style={{
              flex: 1,
              minWidth: 800,
              minHeight: 2500,
              background: theme.colors.background.surface,
              borderRadius: theme.borders.radius.xl,
              padding: theme.spacing.xl,
              boxShadow: theme.shadows.sm,
              borderColor: theme.colors.borders.panel,
              border: `1px solid ${theme.colors.borders.panel}`,
              marginLeft : 480,
              marginRight : 480,
              flexWrap: "nowrap",     
              whiteSpace: "nowrap", 
              overflowX: "auto",  
            }}
          >
            <h2 style={{ marginBottom: theme.spacing.lg, color: theme.colors.text.default,}}>
              Paramètres généraux
            </h2>

            {/* Section 1 */}
            <InfoPanel title="Paramètre 1" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12}
            />
            <div style={{padding:10}}>
              <h4> Selection du type de contrainte </h4>
              <RadioGroup name="horizontalGroup" options={horRadioOptions} value={selectedHorRadioOptions} onChange={setSelectedHorRadioOptions} orientation="horizontal" className="radio-group horizontal"
              style = {{paddingLeft: 10, width: 360, gap: 50}}/>
              <h4> Selection du type de contrainte </h4>
              <RadioGroup name="verticalGroup" options={verRadioOptions} value={selectedVerRadioOptions} onChange={setSelectedVerRadioOptions} orientation="vertical" className="radio-group vertical"
              style = {{paddingLeft: 10, width: 120}}/>
            </div>

             {/* Section 2 */}
            <InfoPanel title="Paramètre 2" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12}
            />
            <div style={{padding:10}}>
              <h4 style= {{marginBottom: 10}}> Selection du type de contrainte </h4>
              <SwitchGroup orientation="horizontal" size="small" style= {{width : 600, gap:100}}
                options={[
                  { label: "Analyse ", value: "auto", enabled: true },
                  { label: "Notifications ", value: "mail", enabled: false },
                  { label: "Sauvegarde ", value: "cloud", enabled: true },
                ]}
                //onChange={(value, state) => console.log(value, state)}
              />
              <h4 style= {{marginBottom: 10}}> Selection du type de contrainte </h4>
              <SwitchGroup orientation="vertical" size="small" style= {{width : 240}}
                options={[
                  { label: "Analyse ", value: "auto", enabled: true },
                  { label: "Notifications ", value: "mail", enabled: false },
                  { label: "Sauvegarde ", value: "cloud", enabled: true },
                ]}
                //onChange={(value, state) => console.log(value, state)}
              />
             </div>
            {/* Section 3 */}
            <InfoPanel title="Paramètre 3" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12} style= {{marginBottom: 12}}
            />
            <h4 style= {{marginBottom: 10}}> Selection du type de contrainte </h4>
            <CheckboxGroup orientation="vertical" style= {{width : 240}}
               options={[
                { label: "Afficher la grille", value: "grid", checked: true },
                { label: "Activer les alertes", value: "alerts", checked: false },
                { label: "Exporter automatiquement", value: "export", checked: true },
              ]}
              onChange={(value, state) => console.log(value, state)}
            />
            <h4 style= {{marginBottom: 10}}> Selection du type de contrainte </h4>
            <CheckboxGroup orientation="horizontal" style= {{width : 640, gap:120}}
               options={[
                { label: "Afficher la grille", value: "grid", checked: true },
                { label: "Activer les alertes", value: "alerts", checked: false },
                { label: "Exporter automatiquement", value: "export", checked: true },
              ]}
              onChange={(value, state) => console.log(value, state)}
            />
            
            {/* Section 4 */}
            <InfoPanel title="Paramètre 4" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12} style= {{marginBottom: 12}}
            />
            <TextfieldGroup
              label=""
              orientation="vertical"
              style= {{width : 460}}
              fields={[
                { name: "firstName", label: "Prénom", value: "pop", placeholder: "Saisir le prénom" },
                { name: "lastName", label: "Nom", value: "pop", placeholder: "Saisir le nom" },
                { name: "email", label: "Email", value: "pop", placeholder: "Adresse e-mail" },
              ]}
              //onChange={(name, value) => setForm({ ...form, [name]: value })}
            />
            <TextfieldGroup
              orientation="horizontal"
              fields={[
                { name: "firstName", label: "Prénom", value: "pop", placeholder: "Saisir le prénom" },
                { name: "lastName", label: "Nom", value: "pop", placeholder: "Saisir le nom" },
                { name: "email", label: "Email", value: "pop", placeholder: "Adresse e-mail" },
                { name: "email", label: "Email", value: "pop", placeholder: "Adresse e-mail" },
              ]}
              //onChange={(name, value) => setForm({ ...form, [name]: value })}
            />
            {/* Section 5 */}
            <InfoPanel title="Paramètre 5" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12} style= {{marginBottom: 12}}
            />
            <DropdownlistGroup
              orientation="vertical"
              disabled={false}
              style= {{width : 460}}
              fields={[
                {
                  name: "status",
                  label: "Statut du projet",
                  value: formData.status,
                  options: [
                    { label: "Actif", value: "active" },
                    { label: "En pause", value: "paused" },
                    { label: "Archivé", value: "archived" },
                  ],
                  placeholder: "Choisir un statut",
                  colorCategory: "projectStatus",
                },
                {
                  name: "role",
                  label: "Rôle utilisateur",
                  value: formData.role,
                  options: [
                    { label: "Administrateur", value: "admin" },
                    { label: "Collaborateur", value: "collab" },
                    { label: "Lecteur", value: "viewer" },
                  ],
                  placeholder: "Sélectionner un rôle",
                  colorCategory: "userRole",
                },
                {
                  name: "priority",
                  label: "Priorité",
                  value: formData.priority,
                  options: [
                    { label: "Haute", value: "high" },
                    { label: "Normale", value: "normal" },
                    { label: "Basse", value: "low" },
                  ],
                  placeholder: "Définir la priorité",
                },
              ]}
              onChange={handleDropdownChange}
            />
            <DropdownlistGroup
              orientation="horizontal"
              disabled={false}
              style= {{width : 900}}
              fields={[
                {
                  name: "status",
                  label: "Statut du projet",
                  value: formData.status,
                  options: [
                    { label: "Actif", value: "active" },
                    { label: "En pause", value: "paused" },
                    { label: "Archivé", value: "archived" },
                  ],
                  placeholder: "Choisir un statut",
                  colorCategory: "projectStatus",
                },
                {
                  name: "role",
                  label: "Rôle utilisateur",
                  value: formData.role,
                  options: [
                    { label: "Administrateur", value: "admin" },
                    { label: "Collaborateur", value: "collab" },
                    { label: "Lecteur", value: "viewer" },
                  ],
                  placeholder: "Sélectionner un rôle",
                  colorCategory: "userRole",
                },
                {
                  name: "priority",
                  label: "Priorité",
                  value: formData.priority,
                  options: [
                    { label: "Haute", value: "high" },
                    { label: "Normale", value: "normal" },
                    { label: "Basse", value: "low" },
                  ],
                  placeholder: "Définir la priorité",
                },
              ]}
              onChange={handleDropdownChange}
            />
  
            {/* Section 6 */}
            <InfoPanel title="Paramètre 6" message="" variant="blue" stripPosition="left"
              border={true} rounded={true} paddingV={6} paddingH={12} style= {{marginBottom: 12}}
            />
            <KpiSummaryList
              color="white"
              bordered
              rounded
              orientation="vertical"
              itemWidth={120}
              itemHeight={70}
              gap={16}
              groups={[
                { label: "Projets actifs", value: 12, color: "green" },
                { label: "En attente", value: 4, color: "blue" },
                { label: "Terminés", value: 9, color: "yellow" },
                { label: "Annulés", value: 2, color: "red" },
              ]}
            />
            <KpiSummaryList
              color="white"
              bordered
              rounded= {false}
              orientation="horizontal"
              textSize="small" 
              itemWidth={80}
              itemHeight={50}
              gap={16}
              groups={[
                { label: "Projets actifs", value: 12, color: "white" },
                { label: "En attente", value: 4, color: "grey" },
                { label: "Terminés", value: 9, color: "yellow" },
                { label: "Annulés", value: 2, color: "red" },
              ]}
            />


            {/* Section 7 */}
            {/* Section 7 */}
<InfoPanel
  title="Paramètre 7 — Composants complémentaires"
  message="Aperçu des composants Corelia UI non utilisés dans les sections précédentes"
  variant="blue"
  stripPosition="left"
  border={true}
  rounded={true}
  paddingV={6}
  paddingH={12}
  style={{ marginBottom: 12 }}
/>

<div style={{ padding: 10 }}>

  {/* UserAvatar */}
  <h4 style={{ marginBottom: 10 }}>UserAvatar</h4>
  <UserAvatar
    name="Jean Dupont"
    size={50}
    image="/assets/avatar-default.png"
    style={{ marginBottom: 20 }}
  />

  {/* Input unitaire */}
  <h4 style={{ marginBottom: 10 }}>Input</h4>
  <Input
    label="Nom"
    placeholder="Saisir un nom"
    value=""
    onChange={() => {}}
    width={300}
  />

  {/* InputGroup */}
  <h4 style={{ marginBottom: 10 }}>InputGroup</h4>
  <InputGroup
    fields={[
      { name: "a", label: "Champ A", value: "", placeholder: "Texte A" },
      { name: "b", label: "Champ B", value: "", placeholder: "Texte B" },
    ]}
    onChange={() => {}}
    orientation="horizontal"
    width={500}
  />

  {/* DropdownList unitaire */}
  <h4 style={{ marginBottom: 10 }}>DropdownList (unitaire)</h4>
  <DropdownList
    label="Catégorie"
    value=""
    onChange={() => {}}
    options={[
      { label: "A", value: "A" },
      { label: "B", value: "B" },
      { label: "C", value: "C" },
    ]}
    width={300}
  />

  {/* DropdownMulti */}
  <h4 style={{ marginBottom: 10 }}>DropdownMulti</h4>
  <DropdownMulti
    label="Multi-choix"
    selectedValues={[]}
    onChange={() => {}}
    options={[
      { label: "Option 1", value: "1" },
      { label: "Option 2", value: "2" },
      { label: "Option 3", value: "3" },
    ]}
    width={300}
  />

  {/* PhoneInput */}
  <h4 style={{ marginBottom: 10 }}>PhoneInput</h4>
  <PhoneInput
    labelList="Pays"
    labelChamp="Numéro"
    value={{ country: "FR", countryCode: "+33", phoneNumber: "" }}
    onChange={() => {}}
  />

  {/* KpiSummary (unitaire) */}
  <h4 style={{ marginTop: 20, marginBottom: 10 }}>KpiSummary</h4>
  <KpiSummary
    kpis={[
      { label: "Projets actifs", value: 12, color: "green" },
      { label: "Retards", value: 2, color: "red" },
    ]}
    color="white"
    bordered
    rounded
  />

</div>

            







          </div>



      </div>
    );
  };

  // ========================================================================
  // 5. Onglet 2 — Exemple : Sauvegarde / Annulation
  // ========================================================================
  const TabTwo = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [visible, setVisible] = useState(true);

    return (
      <div>
        {/* Barre d’actions principale */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing.md,
          }}
        >
          {/* Boutons à gauche */}
          <div style={{ display: "flex", gap: theme.spacing.md, marginLeft: 25 }}>
            <Button variant="blue">Save</Button>
            <Button variant="red">Cancel</Button>
          </div>

          {/* Barre de recherche au centre */}
          <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md, width: 600 }}>
            <TextFilter
              label="Recherche"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher..."
            />
          </div>

          {/* Switch à droite */}
          <div style={{ display: "flex", alignItems: "center", marginRight: 25 }}>
            <Switch
              label="Visible"
              enabled={visible}
              onChange={setVisible}
              showText={false}
              size="small"
              switchStyle={{ transform: "translateY(2px)" }}
            />
          </div>
        </div>

        {/* Statut API */}
        <StatusBlock />
      </div>
    );
  };

  // ========================================================================
  // 6. Onglet 3 — Exemple : Synchronisation / Réinitialisation
  // ========================================================================
  const TabThree = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [autoMode, setAutoMode] = useState(false);

    return (
      <div>
        {/* Barre d’actions principale */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing.md,
          }}
        >
          {/* Boutons à gauche */}
          <div style={{ display: "flex", gap: theme.spacing.md, marginLeft: 25 }}>
            <Button variant="blue">Sync</Button>
            <Button variant="red">Reset</Button>
          </div>

          {/* Barre de recherche au centre */}
          <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md, width: 600 }}>
            <TextFilter
              label="Recherche"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher..."
            />
          </div>

          {/* Switch à droite */}
          <div style={{ display: "flex", alignItems: "center", marginRight: 25 }}>
            <Switch
              label="Auto"
              enabled={autoMode}
              onChange={setAutoMode}
              showText={false}
              size="small"
              switchStyle={{ transform: "translateY(2px)" }}
            />
          </div>
        </div>

        {/* Statut API */}
        <StatusBlock />
      </div>
    );
  };

  // ========================================================================
  // 7. Structure des onglets (BadgesSplitView)
  // ========================================================================
  const tabs = [
    { label: "General", content: <TabOne /> },
    { label: "Caneva", content: <TabTwo /> },
    { label: "Stream", content: <TabThree /> },
  ];

// ================================================================
// Rendu principal
// ================================================================
  return (
    <div style={{ padding: 30}}>
      <Breadcrumb
        items={[
          { label: "Settings", href: "/" },
        ]}
      />
      <PageHeader
        title="Paramètres application"
        subtitle="Configuration de paramètres générales"
      />
      {/* <hr className="page-separator" /> */}
      {/* Contenu de la page */}
      <div style={{ marginTop: 24 }}>
        <BadgesSplitView tabs={tabs} containerStyle={{ background: theme.colors.background.app }}/>
      </div>


      
      
    </div>






  );
};

export default SettingsSubpage;